<div class="modal-backdrop" *ngIf="open">
  <div class="modal-panel modal-lg" role="dialog" aria-modal="true">
    <div class="modal-header">
      <h3>{{ Title | translate }}</h3>
      <button type="button" class="btn btn-ghost btn-icon" (click)="resetForm()">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <div class="modal-body">
      <div class="alert alert-error" *ngIf="isError">{{ errorMessage | translate }}</div>

      <div class="form-loading" *ngIf="loadingDetails">
        <span class="spinner" aria-hidden="true"></span>
        {{ 'USERS.LOADING_PROFILE' | translate }}
      </div>

      <form [formGroup]="form" (ngSubmit)="submit()" *ngIf="!loadingDetails">
        <div class="form-grid">
          <div class="form-field">
            <label for="username">{{ 'USERS.USERNAME' | translate }}</label>
            <input id="username" type="text" formControlName="username" autocomplete="off" />
            <span class="error" *ngIf="form.get('username')?.touched && form.get('username')?.hasError('required')">
              {{ 'USERS.USERNAME_REQUIRED' | translate }}
            </span>
          </div>

          <div class="form-field">
            <label for="role">{{ 'USERS.ROLE' | translate }}</label>
            <div class="role-readonly" *ngIf="mode === 'edit' && isSystemUser; else roleSelect">
              {{ systemUserRoleName }}
            </div>
            <ng-template #roleSelect>
              <select id="role" formControlName="role">
                <option value="">{{ 'USERS.SELECT_ROLE' | translate }}</option>
                <option *ngFor="let role of roles" [value]="roleId(role)">{{ role.name }}</option>
              </select>
            </ng-template>
            <span class="hint" *ngIf="mode === 'edit' && isSystemUser">
              {{ 'USERS.ROLE_LOCKED' | translate }}
            </span>
            <span class="error" *ngIf="form.get('role')?.touched && form.get('role')?.hasError('required')">
              {{ 'USERS.ROLE_REQUIRED' | translate }}
            </span>
          </div>

          <div class="form-field">
            <label for="firstName">{{ 'USERS.FIRST_NAME' | translate }}</label>
            <input id="firstName" type="text" formControlName="firstName" />
          </div>

          <div class="form-field">
            <label for="lastName">{{ 'USERS.LAST_NAME' | translate }}</label>
            <input id="lastName" type="text" formControlName="lastName" />
          </div>

          <div class="form-field full-width">
            <label for="password">{{ 'USERS.PASSWORD' | translate }}</label>
            <div class="password-row">
              <input id="password" [type]="showPassword ? 'text' : 'password'" formControlName="password" />
              <button type="button" class="btn btn-secondary btn-sm" (click)="togglePasswordVisibility()">
                {{ (showPassword ? 'USERS.HIDE' : 'USERS.SHOW') | translate }}
              </button>
            </div>
            <span class="hint">{{ 'USERS.PASSWORD_HINT' | translate }}</span>
          </div>

          <div class="form-field full-width" *ngIf="showAssignments">
            <label>{{ 'USERS.CLASSES' | translate }}</label>
            <div class="class-groups" *ngIf="classGroups.length; else noClassGroups">
              <div class="class-group" *ngFor="let group of classGroups">
                <div class="class-group-header">{{ group.majorName }}</div>
                <div class="checkbox-grid">
                  <label class="checkbox-item" *ngFor="let cls of group.classes">
                    <input
                      type="checkbox"
                      [checked]="isClassSelected(cls.id)"
                      (change)="toggleClass(cls.id, $any($event.target).checked)"
                    />
                    <span>{{ cls.name }}</span>
                  </label>
                </div>
              </div>
            </div>
            <ng-template #noClassGroups>
              <div class="empty-class-groups">{{ 'USERS.NO_CLASS_GROUPS' | translate }}</div>
            </ng-template>
          </div>

          <div class="form-field full-width" *ngIf="showAssignments">
            <label>{{ 'USERS.SUBJECTS' | translate }}</label>
            <div class="checkbox-grid">
              <label class="checkbox-item" *ngFor="let subject of allSubjects">
                <input
                  type="checkbox"
                  [checked]="isSubjectSelected(subject.id)"
                  (change)="toggleSubject(subject.id, $any($event.target).checked)"
                />
                <span>{{ subject.name }}</span>
              </label>
            </div>
          </div>
        </div>
      </form>
    </div>

    <div class="modal-footer">
      <button type="button" class="btn btn-secondary" (click)="resetForm()">
        {{ 'COMMON.CANCEL' | translate }}
      </button>
      <button type="button" class="btn btn-primary" (click)="submit()" [disabled]="loadingDetails">
        {{ 'COMMON.SAVE' | translate }}
      </button>
    </div>
  </div>
</div>
